import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAutocomplete,_vm._b({staticClass:"vd-form-input",attrs:{"value":_vm.choiceFieldValue,"items":_vm.items,"multiple":_vm.multiple,"search-input":_vm.searchInput,"type":undefined,"error-messages":_vm.errorMessages},on:{"update:searchInput":function($event){_vm.searchInput=$event},"update:search-input":function($event){_vm.searchInput=$event},"change":_vm.valueUpdated}},'VAutocomplete',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }